import { Box, Grid, Typography } from '@mui/material'

import React, { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import GlobalCard from '../../../components/GlobalCardComponent'
import EnrolledClassCard from './EnrolledClassCard'
import AttendanceCalendarCard from './AttendanceCalendarCard'
import ProgressCard from './ProgressCard'
import ViewLeaveRequest from './ViewLeaveRequest'
import TodaysDetialsAndSession from './TodaysDetialsAndSession'
import { getAttendanceDetails, getCalandarAttendanceDetails } from '../../testPrepDashboard/Api/DashboardApi'

export default function ViewSelectedClassAttendanceDetails() {
    const navigate =useNavigate()
      const { std_class_detail_id } = useParams();
      const userId = localStorage.getItem("userId")
    const [attendanceDetails, setAttendanceDetails] =useState([])

const [loading, setLoading] =useState(true)
      const handlefetchAttendanceDetails= async () => {
          setLoading(true);
          try {
            const response = await getAttendanceDetails({
              user_id: parseInt(userId),
            
              student_class_details_id: std_class_detail_id,
            });
    
            if (response.status === 200) {
              setAttendanceDetails(response?.data);
              setLoading(false);
            } else {
              setAttendanceDetails([]);
              setLoading(false);
            }
          } catch (error) {
            setAttendanceDetails([]);
            setLoading(false);
          }
        };

        useEffect(() => {
         handlefetchAttendanceDetails()
        }, [])


        
  return (
  <>
  <Grid container spacing={2}>

        <Grid
        item xs={12}
            container
            gap={2}
            alignItems="center"
            onClick={() => navigate("/test-prep/classroom")}
            sx={{ cursor: "pointer" }}
          >
            <Box width={32}>
              <img src="/newdashboard/Classrom/wishlist.png" />
            </Box>
            <Typography
              textAlign="start"
              color="#572575"
              fontFamily="Inter"
              fontSize="24px"
              lineHeight="100%"
              letterSpacing="0px"
              fontStyle="normal"
              style={{ fontWeight: 400 }}
            >
           Attendance Details
            </Typography>
          </Grid>
    
    {/* show todays date and  day */}
    <Grid item xs={12}>
      <TodaysDetialsAndSession attendanceDetails={attendanceDetails}/>
    </Grid>

    <Grid item xs={12}  >
        <Grid container spacing={3}>
        {/* My Progress Card */}
           <Grid item xs={12}  sm={12} md={4}> <ProgressCard attendanceDetails={attendanceDetails} loading={loading}/></Grid>
       

        {/* Enrolled Class card */}
   <Grid item xs={12}  sm={12} md={4}>  <EnrolledClassCard  attendanceDetails={attendanceDetails} loading={loading}/></Grid>
      

        {/* Attendance calandar card */}
           <Grid item xs={12}  sm={12} md={4}> 
        <AttendanceCalendarCard   student_class_details_id={std_class_detail_id}/> </Grid>
    </Grid>
    </Grid>

    {/* leave request */}

    <Grid item xs={12}>
        <ViewLeaveRequest attendanceDetails={attendanceDetails} />
    </Grid>
  </Grid>
  </>
  )
}
